module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[59]302.4792667.woff2";